import {
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
	TimelineItemSubcategoryEnum,
	type TimelineResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

const isReminderItem = (item: TimelineItemResponseDTO): boolean =>
	item.category === TimelineItemCategoryEnum.Reminder ||
	(item.category === TimelineItemCategoryEnum.Notification &&
		item.subcategory === TimelineItemSubcategoryEnum.ReminderTerm);

export const filterReminderItemsByRight = (
	response: TimelineResponseDTO,
	hasRemindersRight: boolean,
): TimelineResponseDTO => {
	if (hasRemindersRight) {
		return response;
	}
	return {
		...response,
		items: response.items.filter((item) => !isReminderItem(item)),
	};
};
